import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import {faMobileScreenButton} from '@fortawesome/free-solid-svg-icons'

library.add(faUserSecret, faBars, faMobileScreenButton)

createApp(App).component('font-awesome-icon', FontAwesomeIcon).use(router).mount('#app')
